import { render, staticRenderFns } from "./grossMargin.vue?vue&type=template&id=217f3228&scoped=true"
import script from "./grossMargin.vue?vue&type=script&lang=js"
export * from "./grossMargin.vue?vue&type=script&lang=js"
import style0 from "./grossMargin.vue?vue&type=style&index=0&id=217f3228&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217f3228",
  null
  
)

export default component.exports